<div class="register-wrapper">
    <div class="register-panel">
        <div *ngIf="currentStep === 'register'">
            <form class="register-form" [formGroup]="registerForm" (ngSubmit)="registerParent()">
                <div class="auth-title" style="margin-bottom: 30px;">Register Parent Account</div>
                
                <!-- Form Fields -->
                <ng-container>
                    <div class="full-width" style="display: flex; align-items: center;">
                        <div class="half-width" style="margin-right: 2%;">
                            <input class="rounded-input" [class.invalid-input]="!isFieldValid.firstName" (change)="getFormValidationErrors('firstName')" placeholder="First Name" formControlName="firstName" required>
                        </div>
                        <div class="half-width">
                            <input class="rounded-input" [class.invalid-input]="!isFieldValid.lastName" (change)="getFormValidationErrors('lastName')" placeholder="Last Name" formControlName="lastName" required>
                        </div>
                    </div>
                    <div class="full-width">
                        <input class="rounded-input" [class.invalid-input]="!isFieldValid.email" (change)="getFormValidationErrors('email')" placeholder="Email Address" formControlName="email" required>
                    </div>
                    <div class="full-width" style="display: flex; align-items: center;">
                        <div class="half-width" style="margin-right: 2%">
                            <input class="rounded-input" [class.invalid-input]="!isFieldValid.phone" (change)="getFormValidationErrors('phone')" placeholder="Phone" formControlName="phone" required>
                        </div>
                    </div>
                    <div class="full-width rc-password-columns" style="display: flex; align-items: center;">
                        <div class="half-width" style="margin-right: 2%">
                            <input class="rounded-input" [class.invalid-input]="!isFieldValid.password" (change)="getFormValidationErrors('password')" type="password" placeholder="Password" formControlName="password" data-password-feedback autocomplete="new-password" required>
                        </div>
                        <div class="half-width">
                            <input class="rounded-input" [class.invalid-input]="!isFieldValid.confirmPassword" (change)="getFormValidationErrors('confirmPassword')" type="password" placeholder="Confirm Password" formControlName="confirmPassword" data-password-confirm autocomplete="new-password" required>
                        </div>
                    </div>
                    <mat-checkbox class="example-margin auth-subtitle" style="margin-top: 10px" color="primary" formControlName="agreed">
                        I agree to the RackCoach&nbsp;
                        <a target="_new" style="color: #2196f3;" href="/Home/LicenseAgreement">Terms of Service</a>,&nbsp;
                        <a style="color: #2196f3;" target="_new" href="/Home/UserAgreement">User Terms of Use</a>&nbsp;and&nbsp;
                        <a style="color: #2196f3;" target="_new" href="/Home/Privacy">Privacy Policy</a>
                    </mat-checkbox>
                </ng-container>
                
                <!-- Submit Button -->
                <div>
                    <button type="submit" class="primary" style="margin-top: 10px;" color="primary">Continue</button>
                </div>
            </form>
        </div>
        
        <div class="register-form" [style.visibility]="currentStep === 'jotform' ? 'visible' : 'hidden'">
            <!-- JotForm Embed -->
            <iframe style="position: absolute" id="JotFormIFrame" title="Form"
                onload="window.parent.scrollTo(0,0)" allowtransparency="true"
                allow="geolocation; microphone; camera; fullscreen" frameborder="0"
                style="min-width:100%;max-width:100%;height:calc(100vh - 200px);border:none;" scrolling="yes"></iframe>
            <script src="https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js"></script>
            <button type="submit" class="primary" style="margin-top: 10px; margin-bottom: 10px" color="primary" (click)="submit()">Complete Registration</button>
            <button (click)="goBackToForm()">Go Back</button>
        </div>
        
        
    </div>
</div>


